import SoloJazz from "./partials/solojazz";
import Header from "./global/header";

let Site = {
  init() {
    SoloJazz.init();
    Header.init();
  }
}

Site.init();



/** WEBPACK FOOTER **
 ** ./es6/main.js
 **/